import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function WineIcon({ width, height, viewBox, className }: IIcon) {
    const newViewProps = '0 0 44.262 44.262' ?? viewBox;
    return (
        <Icon width={width} height={height} viewBox={newViewProps} className={className}>
            <g id="wine">
                <path d="M20.389,21.76H8.481c-0.524,0.926,0.148,7.537,6.329,7.537C20.259,29.297,20.916,22.686,20.389,21.76z" />
                <path
                    d="M15.658,42.498V31.059c3.998-0.713,7.072-4.734,7.072-9.588c0-1.916-0.475-3.77-1.384-5.365l-0.213-0.377H7.663
			l-0.217,0.377c-0.902,1.591-1.378,3.449-1.378,5.365c0,4.887,3.113,8.928,7.146,9.602v11.426
			c-2.327,0.092-4.063,0.445-4.063,0.867c0,0.494,2.368,0.896,5.287,0.896s5.284-0.402,5.284-0.896
			C19.722,42.943,17.989,42.59,15.658,42.498z M7.552,21.471c0-1.51,0.34-2.973,0.986-4.252h11.717
			c0.644,1.281,0.989,2.742,0.989,4.252c0,4.535-3.073,8.223-6.846,8.223C10.623,29.693,7.552,26.006,7.552,21.471z"
                />
                <path
                    d="M34.154,10.949v-4.56h-5.64v4.559c-2.382,1.076-4.044,3.465-4.044,6.25v4.467v14.232v8.365h13.724v-8.365V21.664v-4.467
			C38.194,14.416,36.536,12.025,34.154,10.949z M37.794,22.064v13.432H24.872V22.064H37.794z"
                />
                <rect x="28.514" y="0" width="5.64" height="4.889" />
            </g>
        </Icon>
    );
}
